module.exports = __webpack_public_path__ + "assets/img/bg-prize-4.f61ba676.png";